import { styled } from '@mui/material/styles';
import MuiPaper from '@mui/material/Paper';
const Paper = styled(MuiPaper, {
    name: 'Paper',
    slot: 'container',
})(({ theme }) => {
    var _a, _b;
    return ({
        '& .MuiFormControl-root': {
            width: '100%',
            maxWidth: '100%',
        },
        padding: '20px',
        boxShadow: `0 3px 0px ${(_a = theme.palette.appSpecificColors) === null || _a === void 0 ? void 0 : _a.silverBase}`,
        borderRadius: '5px',
        border: `1px solid ${(_b = theme.palette.appSpecificColors) === null || _b === void 0 ? void 0 : _b.silverBase}`,
    });
});
export default Paper;
